var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.33 193.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "arrow-bg",
    cx: 96.66,
    cy: 96.62,
    r: 96,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-ring",
    fill: "currentColor",
    d: "M95.31.01c58.51-.86,105.42,52.11,97.05,110.14-12.11,83.97-119.65,113.08-171.85,46.09C-28.52,93.34,15.87,1.18,95.31.01ZM87.27,16.06C37.29,21.18,4.83,72.08,18.76,119.99c17.82,61.29,98.45,78.18,139.69,29.25,47.4-56.23,1.79-140.65-71.18-133.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "arrow-head",
    fill: "currentColor",
    d: "M60.78,131.07l50.69-33.31-.62-2.07-50.39-33.68c-8.12-9.89-.96-29.32,13.36-23.08,19.2,16.33,50.81,29.83,68.59,46.4,6.78,6.32,6.57,15.76.55,22.43l-70.44,47.55c-14.2,2.94-19.49-14.03-11.75-24.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9c032bfcb95b6155123a8fb3108563ba.svg";
export { ForwardRef as ReactComponent };